import { PAGE_ROUTES } from '@/constants/routeMapper';

export const blogsYouMayAlsoLike = {
  heading: {
    content: '## You may also like',
    styles: {
      h2: 'text-2xl md:text-3xl font-bold text-royal-875 mb-8',
    },
  },
  viewAllBtn: {
    label: 'View All',
    href: PAGE_ROUTES.blogs,
    styles: {
      button:
        'flex items-center gap-2 px-6 py-2.5 rounded-md border border-(--color-info-500) text-(--color-info-500) font-semibold text-sm hover:bg--(--color-info-500)',
    },
  },
} as const;
